export default __webpack_public_path__ + "static/media/Keira 9781408315972.b9e99ebf.jpg";